import usePagination from '@mui/material/usePagination/usePagination';
import PaginationButton from './PaginationButton';
import { PaginationProps } from '@mui/material';

function Pagination(props: PaginationProps){
  const { items } = usePagination(props);

  return(
    <nav className='pagination'>
      <ul>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;

          // Not render elipsis
          if (type === 'start-ellipsis' || type === 'end-ellipsis'){
            children = undefined;
          }
          // Render page number button
          else if (type === 'page') {
            children = (
              <PaginationButton
                selected={selected}
                type={type}
                children={page}
                {...item}
              />
            );
          }
          // Render nex and prev buttons
          else {
            children = (
              <PaginationButton
                type={type}
                children={type}
                {...item}
              />
            );
          }

          return <li key={index}>{children}</li>;
        })}
      </ul>
    </nav>
  )
} export default Pagination;